import React, { useState } from 'react';
import {
  Box,
  CardMedia,
  IconButton,
  Paper,
} from '@mui/material';
import { 
  ArrowBackIos, 
  ArrowForwardIos,
  PlayArrow
} from '@mui/icons-material';

const MultipleVideosCarousel = ({ videos, title }) => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePrevious = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : videos.length - 1));
    setIsPlaying(false);
  };

  const handleNext = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex < videos.length - 1 ? prevIndex + 1 : 0));
    setIsPlaying(false);
  };

  const handlePlayToggle = () => {
    setIsPlaying(!isPlaying);
    
    // Obtener el elemento de video actual
    const videoElement = document.getElementById(`video-${currentVideoIndex}`);
    if (videoElement) {
      if (!isPlaying) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
    }
  };

  return (
    <Box sx={{ position: 'relative', mb: 3, width: '100%' }}>
      <Paper 
        elevation={3} 
        sx={{ 
          borderRadius: 2, 
          overflow: 'hidden', 
          position: 'relative' 
        }}
      >
        {/* Videos */}
        {videos.map((video, index) => (
          <Box 
            key={index}
            sx={{ 
              display: index === currentVideoIndex ? 'block' : 'none',
              position: 'relative'
            }}
          >
            <CardMedia
              id={`video-${index}`}
              component="video"
              src={video}
              controls={isPlaying}
              alt={`Video ${index + 1} de ${title}`}
              sx={{ 
                width: '100%',
                height: 'auto',
                maxHeight: 400,
                objectFit: 'contain'
              }}
            />
            
            {!isPlaying && (
              <Box 
                sx={{ 
                  position: 'absolute', 
                  top: 0, 
                  left: 0, 
                  right: 0, 
                  bottom: 0, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  cursor: 'pointer'
                }}
                onClick={handlePlayToggle}
              >
                <IconButton 
                  size="large" 
                  sx={{ 
                    bgcolor: 'rgba(255,255,255,0.8)', 
                    '&:hover': { bgcolor: 'white' } 
                  }}
                >
                  <PlayArrow fontSize="large" color="primary" />
                </IconButton>
              </Box>
            )}
          </Box>
        ))}
        
        {/* Navigation arrows */}
        {videos.length > 1 && (
          <>
            <IconButton 
              onClick={handlePrevious}
              sx={{ 
                position: 'absolute', 
                left: 10, 
                top: '50%', 
                transform: 'translateY(-50%)',
                bgcolor: 'rgba(255,255,255,0.5)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.8)' }
              }}
            >
              <ArrowBackIos />
            </IconButton>
            <IconButton 
              onClick={handleNext}
              sx={{ 
                position: 'absolute', 
                right: 10, 
                top: '50%', 
                transform: 'translateY(-50%)',
                bgcolor: 'rgba(255,255,255,0.5)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.8)' }
              }}
            >
              <ArrowForwardIos />
            </IconButton>
          </>
        )}
      </Paper>
      
      {/* Video counter indicator */}
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mt: 1,
          gap: 1
        }}
      >
        {videos.map((_, index) => (
          <Box 
            key={index}
            sx={{ 
              width: 10, 
              height: 10, 
              borderRadius: '50%', 
              bgcolor: index === currentVideoIndex ? 'primary.main' : 'grey.300',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onClick={() => {
              setCurrentVideoIndex(index);
              setIsPlaying(false);
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default MultipleVideosCarousel;